import { Directive, OnInit, OnDestroy, Host, Self, Optional, Renderer2 } from '@angular/core';
import { takeUntilDestroyed } from '../../core/public-api';
import { OverlayPanel } from 'primeng/overlaypanel';
import { takeUntil } from 'rxjs/operators';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { Subject } from 'rxjs';

@Directive({
    selector: 'p-overlayPanel[libModalOverlay]'
})
@RxJSUnsubscribe
export class ModalOverlayDirective implements OnInit, OnDestroy, RxJSUnsubscribable {
    bgMask: HTMLElement;

    constructor(
        @Host() @Self() protected overlayPanel: OverlayPanel,
        protected renderer: Renderer2
    ) {
    }

    ngOnInit(): void {
        this.overlayPanel
            .onShow
            .pipe(
                takeUntil(this.getUnsubFromAllSubs())
            )
            .subscribe(() => this.onOverlayShow());

        this.overlayPanel
            .onHide
            .pipe(
                takeUntil(this.getUnsubFromAllSubs())
            )
            .subscribe(() => this.onOverlayHide());
    }

    onOverlayShow(): void {
        if (!this.bgMask) {
            this.bgMask = this.renderer.createElement('div');
            this.renderer.addClass(this.bgMask, 'overlay-bg-mask');
            // this.renderer.setStyle(this.bgMask, 'z-index', '' + ++DomHandler.zindex)
            this.renderer.appendChild(this.overlayPanel.appendTo, this.bgMask)
        }
    }

    onOverlayHide(): void {
        this.bgMask.remove();
        this.bgMask = null;
    }

    ngOnDestroy(): void {
        if (this.bgMask) {
            this.bgMask.remove();
        }
    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }
}